import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, TextInputGroup, TextInputGroupMain, TextInputGroupUtilities } from '@patternfly/react-core';
import { EyeIcon, EyeSlashIcon } from '@patternfly/react-icons';
import { useCallback, useContext, useRef, useState } from 'react';
import { useFieldValue } from '../hooks/field-value';
import { useSuggestions } from '../hooks/suggestions';
import { SchemaContext } from '../providers/SchemaProvider';
import { isDefined, isRawString } from '../utils';
import { FieldActions } from './FieldActions';
import { FieldWrapper } from './FieldWrapper';
export const PasswordField = ({ propName, required, onRemove: onRemoveProps }) => {
    var _a, _b;
    const { schema } = useContext(SchemaContext);
    const [passwordHidden, setPasswordHidden] = useState(true);
    const { value = '', errors, disabled, isRaw, onChange } = useFieldValue(propName);
    const lastPropName = propName.split('.').pop();
    const clearButtonAriaLabel = isDefined(onRemoveProps) ? 'Remove' : `Clear ${lastPropName} field`;
    const toggleRawAriaLabel = `Toggle RAW wrap for ${lastPropName} field`;
    const inputRef = useRef(null);
    const onFieldChange = useCallback((_event, value) => {
        onChange(value);
    }, [onChange]);
    const onRemove = () => {
        var _a;
        if (isDefined(onRemoveProps)) {
            onRemoveProps(propName);
            return;
        }
        onChange(undefined);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const toggleRawValueWrap = () => {
        if (typeof value !== 'string')
            return;
        const newValue = isRawString(value) ? value.substring(4, value.length - 1) : `RAW(${value})`;
        onChange(newValue);
    };
    const setValue = useCallback((value) => {
        onFieldChange(null, value.toString());
    }, [onFieldChange]);
    const suggestions = useSuggestions({
        propName,
        schema,
        inputRef,
        value,
        setValue,
    });
    const id = `${propName}-popover`;
    return (_jsx(FieldWrapper, { propName: propName, required: required, title: schema.title, type: "secret", description: schema.description, defaultValue: (_a = schema.default) === null || _a === void 0 ? void 0 : _a.toString(), errors: errors, isRaw: isRaw, children: _jsxs(TextInputGroup, { validated: errors ? 'error' : undefined, isDisabled: disabled, children: [_jsx(TextInputGroupMain, { type: passwordHidden ? 'password' : 'text', role: "textbox", id: propName, name: propName, placeholder: (_b = schema.default) === null || _b === void 0 ? void 0 : _b.toString(), value: value, onChange: onFieldChange, "aria-label": schema.title, "aria-describedby": id, ref: inputRef }), suggestions, _jsxs(TextInputGroupUtilities, { children: [_jsx(Button, { variant: "plain", "data-testid": `${propName}__toggle-visibility`, "aria-label": passwordHidden ? `Show ${lastPropName} value` : `Hide ${lastPropName} value`, onClick: () => {
                                setPasswordHidden(!passwordHidden);
                            }, children: passwordHidden ? _jsx(EyeIcon, {}) : _jsx(EyeSlashIcon, {}) }), _jsx(FieldActions, { propName: propName, clearAriaLabel: clearButtonAriaLabel, toggleRawAriaLabel: toggleRawAriaLabel, onRemove: onRemove, toggleRawValueWrap: toggleRawValueWrap })] })] }) }));
};
//# sourceMappingURL=PasswordField.js.map